module.exports = __webpack_public_path__ + "img/PR2.d8e66bc1.png";